import React, { useEffect, useRef } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

type HourRow = {
  hour: number;
  units_ordered: number;
  units_active: number;
  units_cancelled: number;
};

const HourlyChart = ({ hours }: { hours: HourRow[] }) => {
  const idRef = useRef(`fbs-hourly-${Math.random().toString(36).slice(2)}`);

  useEffect(() => {
    const root = am5.Root.new(idRef.current);
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        layout: root.verticalLayout,
      })
    );

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "label",
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 20 }),
      })
    );
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );

    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Заказано",
        xAxis,
        yAxis,
        valueYField: "units_ordered",
        categoryXField: "label",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY}",
        }),
      })
    );

    const data = hours.map((h) => ({
      label: String(h.hour).padStart(2, "0"),
      units_ordered: h.units_ordered,
    }));
    xAxis.data.setAll(data);
    series.data.setAll(data);

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    return () => {
      root.dispose();
    };
  }, [hours]);

  return <div id={idRef.current} style={{ width: "100%", height: 280 }} />;
};

export default HourlyChart;
